import React,{useEffect, useState} from "react";
import { Link } from "react-router-dom";
import Background2 from "../assets/images/personal/logo-con-texto2.png"
import Background1 from "../assets/images/personal/young-girl-doing-pilates-exercises-with-a-reformer-2024-02-27-22-14-19-utc.jpg"
import Foto15 from "../assets/images/personal/foto15.jpg"
import Foto11 from "../assets/images/personal/foto11.jpg"
import Foto8 from "../assets/images/personal/foto8.jpg"
import Flyer1 from "../assets/images/personal/flyer1.png";
import Flyer2 from "../assets/images/personal/flyer2.png";
import Flyer3 from "../assets/images/personal/Flyer_primavera.png";
import PersonalNavbar from "../componants/navbar/personalNavbar";
import SmallFooter from "../componants/footer/smallFooter";
import ScrollTop from "../componants/scrollTop";
import { TypeAnimation } from 'react-type-animation';
import "../../node_modules/react-modal-video/scss/modal-video.scss"
import { Background, Parallax } from 'react-parallax';
import "react-18-image-lightbox/style.css"

import { portfolioData,portfolioImage } from "../data/data";

import {FiAirplay, FiAperture, FiCamera,FiCompass,FiSettings,FiMessageCircle,FiArrowRightCircle,MdArrowForward} from "../assets/icons/vander"

import scale from "../assets/images/gym/icon/scale.png"
import kettlebell from "../assets/images/gym/icon/kettlebell.png"
import waterBottle from "../assets/images/gym/icon/water-bottle.png"
import fea01 from "../assets/images/gym/fea01.jpg"
import fea02 from "../assets/images/gym/fea02.jpg"
import fea03 from "../assets/images/gym/fea03.jpg"

import {MdOutlineArrowForward} from "../assets/icons/vander"
import cta from "../assets/images/food/cta.jpg"
import {BsTelephone,FiMail,FiMapPin,BsInstagram,BsWhatsapp} from "../assets/icons/vander"
import { Link as Link1 } from 'react-scroll';
import GetInTuchFour from "../componants/getInTuchFour";
import GetInTuchCustom from "../componants/getInTuchCustom";
import CookiesConsent from "../componants/cookiesConsent";

export default function IndexPersonalCustom(){
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [pricing, setPricing] = useState(false)
    

    const filteredData = selectedCategory
        ? portfolioData.filter((item) => item.category === selectedCategory)
        : portfolioData;

    const homeData = [
        {
            icon:FiAirplay,
            title:"¿Que es un reformer?",
            desc:["El reformador de posturas ayuda a ejecutar cada uno de los ejercicios de manera fluida y controlada evitando lesiones"]
        },
        {
            icon:FiAperture,
            title:"Pilates para todos",
            desc:["Trabajas sentado",
                "Tienes un trabajo físico",
                "Practicas otros deportes",
                "Eres mayor",
                "Eres joven",
                "Embarazada, postparto",
                "Practicabas pilates y quieres mejorar el nivel",
            ]
        },
    ]

    const pilatesParaTodosData = [
        {
            icon:"fa-solid fa-signal-fair",
            title:"Principiantes",
            desc:"Clase indicada para personas que estan empezando, sin patologias graves.",
        },
        {
            icon:"fa-solid fa-signal-good",
            title:"Intermedio",
            desc:"Clase equilibrada dirigida a mejorar las distintas cualidades físicas, fuerza, flexibilidad, equilibrio, coordinación mejorando la conciencia corporal."
        },
        {
            icon:"fa-solid fa-signal-strong",
            title:"Avanzado",
            desc:"Clase dinámica, condición física media alta. Se necesita valoración inicial del entrenador."
        },
        {
            icon:"fa-solid fa-people-group",
            title:"Multinivel",
            desc:"Todos los días puedes venir a practicar pilates en el horario de 14 a 16 Hs. Adaptamos el nivel al grupo."
        },
    ]
    const aboutData = [
        {
            image:scale,
            image1:fea01,
            title:"Progression",
            desc:"After you decide to start training we will make sure you get the best fitness program. Our sport experts and latest sports equipment are the winning combination."
        },
        {
            image:kettlebell,
            image1:fea02,
            title:"Workouts",
            desc:"After you decide to start training we will make sure you get the best fitness program. Our sport experts and latest sports equipment are the winning combination."
        },
        {
            image:waterBottle,
            image1:fea03,
            title:"Nutrition",
            desc:"After you decide to start training we will make sure you get the best fitness program. Our sport experts and latest sports equipment are the winning combination."
        },
    ]

    const flyers = [];


    function handleChange(e) {
        setPricing(e.target.checked);
    }

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        setShowPopup(flyers.length > 0); // Show the popup every time the component mounts
    }, []); // Empty dependency array ensures this runs only once on mount

    const handleOpenPopup = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };


    return(
        <>
        <PersonalNavbar/>

        <section className="bg-home personal-hero d-flex align-items-center background-effect overflow-hidden z-index-1" id="home">
            <Parallax strength={500} style={{position:"absolute", width:"100%", height:"100%"}} speed={-100}>
                <Background className="custom-bg">
                    <img src={Background1} alt="fill murray" />
                </Background>
            </Parallax>
            <div className="personal-overlay bg-overlay bg-primary-gradient-overlay"></div>
            <ul className="circles p-0 mb-0"><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li></ul>
        </section>

        <section className="w-100 d-flex justify-content-center" style={{ marginTop:'-100px' }}>
            <div className="container-fluid position-relative">
                <div className="container position-relative z-index-1">
                    <div className="row mt-5">
                        <div className="col">
                            <div className="title-heading">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <h4 className="display-6 title fw-bold mb-0">&nbsp;<br/> <br/> 
                                        <TypeAnimation
                                                sequence={[
                                                    // Same substring at the start will only be typed out once, initially
                                                    '\"La salud física es el primer requisito para la felicidad\"',
                                                    2000,
                                                ]}
                                                wrapper="span"
                                                speed={5}
                                                className="typewrite" 
                                                repeat={Infinity}
                                                cursor={false}
                                                />
                                        </h4>
                                        <h4 className="">Joseph Pilates</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* <section className="section pb-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="features-absolute">
                            <div className="row">
                                {aboutData.map((item,index) => {
                                    return(
                                        <div className="col-lg-4 col-md-4 col-12" key={index}>
                                            <div className="card features feature-primary feature-image text-center bg-white rounded shadow-md p-md-5 p-4 overflow-hidden">
                                                <img src={item.image} className="avatar avatar-small d-block mx-auto" alt=""/>

                                                <div className="content mt-4">
                                                    <h4>{item.title}</h4>
                                                    <p className="text-muted mt-3 mb-0">{item.desc}</p>
                                                </div>

                                                <div className="overlay card-img">
                                                    <img src={item.image1} className="img-fluid" alt=""/>
                                                    <div className="card-overlay"></div>
                                                </div>

                                                <div className="fea-title position-absolute bottom-0 start-0 end-0 text-center mb-4">
                                                    <Link to="#" className="h4 text-white title-dark title">{item.title}</Link>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2 mt-4">
                                <h4 className="title">"La salud física es el primer requisito para la felicidad"</h4>
                                <div className="mb-4 justify-content-end">Joseph Pilates</div>
                                <p className="text-muted para-desc mb-0 mx-auto">
                                    Contamos con las mejores maquinas de pilates del mercado<br/>
                                    Reformer con ??? variedad de correas y poleas que crean tensión, aumentan la intensidad de diferentes entrenamientos y movimientos
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {homeData.map((item,index)=>{
                            const Icon = item.icon
                            return(
                                <>
                                    <div className="col-lg-3 col-sm-1 mt-4 pt-2" key={index}></div>
                                    <div className="col-lg-6 col-sm-10 mt-4 pt-2" key={index}>
                                        <div className="card features feature-primary feature-clean feature-transition p-4 border-0 shadow rounded overflow-hidden">
                                            <div className="icons text-center rounded">
                                                <Icon className="icon d-block rounded h4 mb-0"/>
                                            </div>
                                            <div className="content mt-4">
                                                <Link to={`/page-service-detail/${item.id}`} className="h5 text-dark title">{item.title}</Link>
                                                <ul>{item.desc.map((d,index)=>{
                                                    return (<li className="text-muted mt-3">{d}</li>)
                                                })}</ul>
                                            </div>

                                            <div className="feature-ovelay-one"></div>
                                            <div className="feature-ovelay-two"></div>
                                            <div className="feature-ovelay-three"></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-1 mt-4 pt-2" key={index}></div>
                                </>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section> */}



        <section className="section" id="pilatesMaquinaGrupal" style={{paddingBottom:0}}>
            <div className="container container-grupal">
                <img src={ Foto15 } className="img-grupal" />
            </div>
            <div className="container">
                {/* <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary fw-normal">.</h6>
                            <h4 className="title mb-4">Pilates máquina grupal</h4>
                            <p className="text-muted para-desc mb-0 mx-auto">Launch your campaign and benefit from our expertise on designing and managing conversion centered bootstrap html page.</p>
                        </div>
                    </div>
                </div> */}
                <div className="row">
                    {pilatesParaTodosData.map((item,index)=>{
                        const Icon = item.icon
                        return(
                            <div className="col-lg-6 col-sm-12 mt-4 pt-2" key={index}>
                                <div className="card features feature-primary feature-clean feature-transition p-4 border-0 shadow rounded overflow-hidden">
                                    <div className="icons text-center rounded">
                                        {/* <Icon className="icon d-block rounded h4 mb-0"/> */}
                                        <i className={`${item.icon} text-primary`} style={{ fontSize:'1.5rem' }}></i>
                                        {/* <i className="fa-solid fa-signal-strong"></i> */}
                                    </div>
                                    <div className="content mt-4">
                                        <p className="h5 text-dark title">{item.title}</p>
                                        <p className="mt-3">{item.desc}</p>
                                    </div>

                                    <div className="feature-ovelay-one"></div>
                                    <div className="feature-ovelay-two"></div>
                                    <div className="feature-ovelay-three"></div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>

        <section id="pilatesMaquinaIndividual" className="mt-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-5 col-12">
                        <div className="positon-relative">
                            <img src={Foto11} className="img-fluid rounded-md shadow-md" alt=""/>
                        </div>
                    </div>
                    <div className="col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div className="section-title ms-lg-5">
                            <h4 className="title mb-4"><i class="fa-solid fa-person text-primary" style={{ fontSize: '3rem' }}></i> Pilates individual</h4>
                            <p className="mb-0">Totalmente adaptado a ti, para corregir postura, si deseas nivelarte para incorporarte a un grupo o alcanzar un objetivo concreto.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="pilatesPrenatalYPostparto" className="mt-5">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div className="section-title ms-lg-5">
                            <h4 className="title mb-4"><i class="fa-solid fa-person-pregnant text-primary" style={{ fontSize: '3rem' }}></i> Pilates prenatal y postparto</h4>
                            <p className="mb-0">A partir del segundo trimestre podrás fortalecer el cuerpo para un buen parto y recuperarte mucho más rápido con estas clases.</p>
                        </div>
                    </div>
                    <div className="col-md-5 col-12">
                        <div className="positon-relative">
                            <img src={Foto8} className="img-fluid rounded-md shadow-md" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section" id="tarifasYHorarios">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary fw-normal">&nbsp;</h6>
                            <h4 className="h1">Reserva App</h4>
                        </div>

                        <h5 className="text-center text-primary h1">Suscripción mensual</h5>
                        <div className="switcher-pricing d-flex justify-content-center align-items-center mb-4 pb-2">
                            <label for="switcher" className={pricing === false ? "toggler h3 mb-0 text-muted toggler--is-active"  :  "toggler h3 mb-0 text-muted"} id="filt-monthly">Grupal</label>
                            <div className="form-check form-switch mx-3">
                                <input className="form-check-input" type="checkbox"  id="switcher" onChange={handleChange}/>
                            </div>
                            <label for="switcher" className={pricing === true ? "toggler h3 mb-0 text-muted toggler--is-active"  :  "toggler h3 mb-0 text-muted"} id="filt-yearly">Individual</label>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        
                        {pricing === false ? 
                            <div id="yearly" className="wrapper-full ">
                                <div className="row align-items-center">
                                    <div className="col-1"></div>
                                    <div className="col-lg-10">
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                                                <div className="pricing text-center rounded position-relative shadow">
                                                    <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                        <h5 className="price-title text-white title-dark">1 día</h5>
                                                        <p className="mb-0 text-white-50">a la semana</p>
                                                    </div>
                                                    <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                        <span className="price h4 mb-0 ms-1">€80</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                                                <div className="pricing text-center rounded position-relative shadow">
                                                    <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                        <h5 className="price-title text-white title-dark">2 días</h5>
                                                        <p className="mb-0 text-white-50">a la semana</p>
                                                    </div>
                                                    <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                        <span className="price h4 mb-0 ms-1">€140</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2">
                                                <div className="pricing text-center rounded position-relative shadow">
                                                <div className="ribbon ribbon-right ribbon-warning overflow-hidden"><span className="text-center d-block shadow small h6">Best</span></div>
                                                    <div className="price-header rounded-top bg-primary bg-white-dark pt-5 pb-5">
                                                        <h5 className="price-title text-white title-dark">3 días</h5>
                                                        <p className="mb-0 text-white-50">a la semana</p>
                                                    </div>
                                                    <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                        <span className="price h4 mb-0 ms-1">€180</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-sm-12 mt-4 pt-2">
                                                <div className="card features feature-primary feature-clean feature-transition p-4 border-0 shadow rounded overflow-hidden bg-light">
                                                    <div className="content mt-4 text-center">
                                                        <Link className="h5 text-dark title">Cancelación 24 Hs antes sin penalización</Link>
                                                        {/* <p className="text-muted">(Caducidad 3 meses)</p> */}
                                                    </div>

                                                    <div className="feature-ovelay-one"></div>
                                                    <div className="feature-ovelay-two"></div>
                                                    <div className="feature-ovelay-three"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row align-items-center mt-5">
                                    <div className="col-lg-3 col-md-6 col-12"></div>
                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                                        <div className="pricing text-center rounded position-relative shadow">
                                            <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                <h5 className="price-title text-white title-dark">Clase suelta</h5>
                                            </div>
                                            <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                <span className="price h4 mb-0 ms-1">€28</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                                        <div className="pricing text-center rounded position-relative shadow">
                                            <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                <h5 className="price-title text-white title-dark">Bono x 5 clases</h5>
                                            </div>
                                            <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                <span className="price h4 mb-0 ms-1">€140</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-12"></div>
                                    <div className="col-lg-3 col-md-6 col-12"></div>
                                    <div className="col-lg-6 col-sm-12 mt-4 pt-2">
                                        <div className="card features feature-primary feature-clean feature-transition p-4 border-0 shadow rounded overflow-hidden bg-light">
                                            <div className="content mt-4 text-center">
                                                <Link className="h5 text-dark title">Caducidad 3 meses</Link>
                                                {/* <p className="text-muted">(Caducidad 3 meses)</p> */}
                                            </div>

                                            <div className="feature-ovelay-one"></div>
                                            <div className="feature-ovelay-two"></div>
                                            <div className="feature-ovelay-three"></div>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <div id="monthly" className="wrapper-full">
                            <div className="row align-items-lg-center">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                                        <div className="pricing text-center rounded position-relative shadow">
                                            <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                <h5 className="price-title text-white title-dark">Clase suelta</h5>
                                                <p className="mb-0 text-white-50">Sesión</p>
                                            </div>
                                            <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                <span className="price h4 mb-0 ms-1">€55</span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                                        <div className="pricing text-center rounded position-relative shadow">
                                            <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                <h5 className="price-title text-white title-dark">1 día</h5>
                                                <p className="mb-0 text-white-50">semana</p>
                                            </div>
                                            <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                <span className="price h4 mb-0 ms-1">€200</span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                                        <div className="pricing text-center rounded position-relative shadow">
                                            <div className="ribbon ribbon-right ribbon-warning overflow-hidden"><span className="text-center d-block shadow small h6">Best</span></div>
                                            <div className="price-header rounded-top bg-primary bg-white-dark pt-5 pb-5">
                                                <h5 className="price-title text-white title-dark">2 días</h5>
                                                <p className="mb-0 text-white-50">semana</p>
                                            </div>
                                            <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                <span className="price h4 mb-0 ms-1">€370</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 col-12 mt-4 pt-2">
                                        <div className="pricing text-center rounded position-relative shadow">
                                            <div className="price-header rounded-top bg-dark bg-white-dark pt-5 pb-5">
                                                <h5 className="price-title text-white title-dark">Bono x 5</h5>
                                                <p className="mb-0 text-white-50">sesiones</p>
                                            </div>
                                            <div className="d-flex justify-content-center bg-light border-bottom py-4">
                                                <span className="price h4 mb-0 ms-1">€250</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-sm-12 mt-4 pt-2">
                                        <div className="card features feature-primary feature-clean feature-transition p-4 border-0 shadow rounded overflow-hidden bg-light">
                                            <div className="content mt-4 text-center">
                                                <Link className="h5 text-dark title">Cancelación 24 Hs antes sin penalización</Link>
                                            </div>

                                            <div className="feature-ovelay-one"></div>
                                            <div className="feature-ovelay-two"></div>
                                            <div className="feature-ovelay-three"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    
                    }
                        
                    </div>
                </div>
            </div>
        </section>

        <GetInTuchFour/>

        <section className="" id="dondeEstamos" style={{ padding: '0 !important' }}>
            <div className="container-fluid">
                <div className="row justify-content-center mt-3">
                    <div className="col-12">
                        <div className="section-title text-center pb-2">
                            {/* <h6 className="text-primary fw-normal">&nbsp;</h6> */}
                            {/* <h4 className="title">Donde estamos</h4> */}
                            <p className="para-desc mx-auto mb-0 h5">C/ Bravo Murillo, 60 28003 Madrid</p>
                            <p className="para-desc mx-auto mb-0 h5">Horario de clases 9:00 a 14:00 y de 17:00 a 21:00</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="card map border-0">
                            <div className="card-body p-0">
                                <iframe id="googleMapsLocation" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3036.4377542271027!2d-3.7063396232692054!3d40.4434471714354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd422857f5dbe0b1%3A0x41c7029922fc17e9!2sC.%20de%20Bravo%20Murillo%2C%2060%2C%20Chamber%C3%AD%2C%2028003%20Madrid%2C%20Spain!5e0!3m2!1sen!2smx!4v1733275632482!5m2!1sen!2smx" width="600" height="450" style={{ border:"0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <SmallFooter/>
        <ScrollTop/>
        <CookiesConsent/>

        <div>

        {showPopup && (
            <div className="popup-overlay">
                <div className={flyers.length === 2 ? 'popup-content-2pics' : 'popup-content-1pic'}>
                    <button className="close-button" onClick={handleClosePopup}>x</button>
                    <div className={flyers.length === 2 ? 'image-container-2pics' : 'image-container-1pic'}>
                        {
                            flyers.map(flyer => <img src={flyer} />)
                        }
                    </div>
                </div>
            </div>
        )}
        </div>

        </>
    )
}

// rosa: #dacbd2
// lila: #735fb3
// verde: #bdcec8
